module.exports = __webpack_public_path__ + "img/TZS09703.0230e2bb.jpeg";